import React, { useState } from 'react';
import './PersonalizedGoals.css';

const PersonalizedGoals = () => {
  const [goal, setGoal] = useState('');
  const [commission, setCommission] = useState(0);

  const handleGoalChange = (e) => {
    setGoal(e.target.value);
  };

  // Dummy commission for now
  const estimatedCommission = 5000;

  return (
    <div className="personalized-goals">
      <h2>Personalized Goals & Coaching</h2>
      <div className="goal-input">
        <label htmlFor="personal-goal">Your Personal Goal:</label>
        <input
          type="text"
          id="personal-goal"
          value={goal}
          onChange={handleGoalChange}
          placeholder="e.g., Saving for a house"
        />
      </div>
      <div className="commission-progress">
        <h3>Commission Progress</h3>
        <p>Estimated Commission: ${estimatedCommission}</p>
        <p>Your Goal: {goal || 'Not set'}</p>
      </div>
    </div>
  );
};

export default PersonalizedGoals;